"use client";

import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const dishes = [{
  id: 1,
  name: "Sizzling Fajitas",
  description: "Tender steak or chicken with peppers and onions, served on a hot skillet with warm tortillas.",
  image: "https://texasmargaritasmexicanrestaurant.com/wp-content/uploads/2026/01/fajitas-sizzinling.webp",
  link: "/MenuPage"
}, {
  id: 2,
  name: "Signature Enchiladas",
  description: "Classic enchiladas smothered in our homemade sauce, topped with cheese and fresh cilantro.",
  image: "https://texasmargaritasmexicanrestaurant.com/wp-content/uploads/2026/01/4fd05bf9-eca8-49cd-9fcd-32e457e4db65-retina-large.jpg",
  link: "/MenuPage"
}, {
  id: 3,
  name: "Fresh Tacos Platter",
  description: "Choose from steak, chicken, carnitas, or shrimp, topped with fresh pico de gallo and guacamole.",
  image: "https://texasmargaritasmexicanrestaurant.com/wp-content/uploads/2026/01/TACOS-TEXAS-MARGARAITAS-C.webp",
  link: "/MenuPage"
}];
export default function FeaturedMenuHighlights() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const refs = [ref1, ref2, ref3];
  const visibilities = [isVisible1, isVisible2, isVisible3];
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-4xl font-bold text-foreground sm:text-5xl">
            Featured Menu Highlights
          </h2>
          <p className="mt-4 text-lg text-foreground">
            Discover our most beloved authentic Mexican dishes
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {dishes.map((dish, i) => <div key={dish.id} data-index={i} ref={refs[i] as any} className="transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
          opacity: visibilities[i] ? 1 : 0,
          transform: visibilities[i] ? "translateY(0)" : "translateY(20px)",
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="group h-full overflow-hidden rounded-lg bg-muted-light-background shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-strong">
                <div className="overflow-hidden">
                  <img src={dish.image} alt={dish.name} className="h-64 w-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
                </div>
                
                <CardHeader>
                  <CardTitle className="font-display text-2xl text-foreground">
                    {dish.name}
                  </CardTitle>
                </CardHeader>

                <CardContent>
                  <CardDescription className="text-base text-foreground">
                    {dish.description}
                  </CardDescription>
                </CardContent>

                <CardFooter>
                  <Link to={dish.link} className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 font-semibold text-foreground-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:-translate-y-0.5 hover:bg-primary-hover hover:shadow-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent active:translate-y-0 active:bg-primary-active">
                    View Details
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}